import Vue from 'vue';
import Vuex from 'vuex';
// Modules 
import SecurityModule from '@/store/modules/Security';
import GameStatusModule from '@/store/modules/GameStatus';
import GameActionModule from '@/store/modules/GameAction';
import GameModule from '@/store/modules/Game';
import StuffModule from '@/store/modules/Stuff';
import SurveyModule from '@/store/modules/Survey';
import ModalModule from '@/store/modules/Modal';
import TicketModule from '@/store/modules/Ticket';
import AdvertisingModule from '@/store/modules/Advertising';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    SecurityModule,
    GameStatusModule,
    GameActionModule,
    GameModule,
    StuffModule,
    SurveyModule,
    ModalModule,
    TicketModule,
    AdvertisingModule
  }
});
